import { render, staticRenderFns } from "./McpOauthAuthorizeView.vue?vue&type=template&id=452bb774&scoped=true"
import script from "./McpOauthAuthorizeView.vue?vue&type=script&lang=js"
export * from "./McpOauthAuthorizeView.vue?vue&type=script&lang=js"
import style0 from "./McpOauthAuthorizeView.vue?vue&type=style&index=0&id=452bb774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bb774",
  null
  
)

export default component.exports